<template>
    <b-table
        :data="records"
        :striped="true"
        :loading="loading"
        :mobile-cards="true"

        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        backend-sorting
        :default-sort-direction="sortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"
        :detailed="!!contract"
        :show-detail-icon="!!contract"

        :paginated="paginated"
        :sort-icon="'chevron-up'"
    >
        <template>
            <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                    {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                </b-button>
            </b-table-column>

            <b-table-column v-slot="props" field="min_plus" label="Wijziging" width="150">
                <span>{{ props.row.min_plus == 'min' ? '-' : '+' }}{{ props.row.price }}{{ props.row.type == 'euro' ? ' euro' : '%'}}</span>
            </b-table-column>

            <b-table-column v-slot="props" field="date_from" label="Vanaf" sortable width="200">
                <span>{{ props.row.date_from|humanDate }}</span>
            </b-table-column>

            <b-table-column v-slot="props" field="affected" label="Contracten" :visible="!contract" width="150">
                <span>{{ props.row.affected_count }}</span>
            </b-table-column>

            <b-table-column v-slot="props" field="userid" label="Aangemaakt door" width="200">
                <span v-if="hideSensitiveData">********</span>
                <span v-else>
                    <span v-if="props.row.user">{{ props.row.user.name }}</span>
                </span>
            </b-table-column>

            <b-table-column v-slot="props" numeric :width="$route.name == 'ContractsPriceChanges' ? 175 : 100">
                <b-tooltip label="Download het overzicht in Excel" v-show="$route.name == 'ContractsPriceChanges'">
                    <b-button @click="$store.commit('startExport', {id: props.row.id})" type="is-light" size="is-small" :to="{ name: 'ContractsPriceChangesRecord', params: {id: props.row.id} }">Exporteer</b-button>
                </b-tooltip>
                <b-tooltip :label="`${props.row.affected_count == 1 ? 'Klant' : 'Klanten'} mailen`" v-show="$route.name == 'ContractsPriceChanges'">
                    <b-button tag="router-link" type="is-primary" size="is-small" :to="{ name: 'MailRecord', params: {id: 'nieuw'}, query: { 'pricechange': props.row.id } }" icon-right="paper-plane" />
                </b-tooltip>
                <b-button tag="router-link" v-if="!user.deurwaarder" type="is-dark" size="is-small" :to="{ name: 'ContractsPriceChangesRecord', params: {id: props.row.id} }">Bekijken</b-button>
            </b-table-column>
        </template>

        <template #detail="props">
            <b-table
                :data="[props.row]"
                :striped="true"
                :loading="loading"
                :mobile-cards="true"
            >
                <b-table-column v-slot="props" field="prodtype" label="Type" width="160">
                    {{ props.row.prodtype == 'box' ? 'Box' : props.row.prodtype == 'product' ? 'Product' : props.row.prodtype }}
                </b-table-column>
                <b-table-column v-slot="props" field="name" :label="props.row.type == 'box' ? 'Nmr.' : 'Naam'">
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column v-slot="props" field="old_price" label="Oude prijs" width="180">
                    &nbsp;€&nbsp;{{ props.row.old_price }}
                </b-table-column>

                <b-table-column v-slot="props" field="new_price" label="Nieuwe prijs" width="180">
                    &nbsp;€&nbsp;{{ props.row.new_price }}
                </b-table-column>

                <b-table-column v-slot="props" numeric width="100" v-if="!user.deurwaarder">
                    <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: (props.row.prodtype == 'box' ? 'BoxesRecord' : 'ProductsRecord'), params: {id: props.row.product} }">Bekijken</b-button>
                </b-table-column>

                <!-- <b-table-column v-slot="props" field="status" label="Status" width="150" sortable>
                    <b-tag :type="_.isNull(creditInvoice.row.status) ? 'is-dark' : creditInvoice.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], creditInvoice.row.status) ? 'is-danger' : _.includes(['one_fail'], creditInvoice.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], creditInvoice.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(creditInvoice.row.status) }}</b-tag>
                </b-table-column>

                <b-table-column v-slot="props" field="total_price" label="Totaal" width="180">
                    <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                    <span v-else-if="creditInvoice.row.total" class="text-danger">-&nbsp;€{{ creditInvoice.row.total }}</span>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" field="send_at" label="Verstuurd" width="180" sortable>
                    {{ creditInvoice.row.send_at || 'Nee' }}
                </b-table-column>

                <b-table-column v-slot="props" numeric width="100">
                    <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: creditInvoice.row.id} }">Bekijken</b-button>
                </b-table-column> -->
            </b-table>
        </template>

        <template #empty>
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p class="margin0" v-if="loading === false">Geen prijswijzigingen gevonden.</p>
                    <p class="margin0" v-else>Laden...</p>
                </div>
            </section>
        </template>
    </b-table>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'
import excelExportingMixin from '@/mixins/excelExportMixin'

export default {
    name: 'ContractsPriceChangeTable',
    mixins: [filtersMixin, paramsMixin, excelExportingMixin],

    props: {
        contract: {
            type: String|Number,
            default: 0,
            required: false,
        }
    },

    data () {
        return {
            records: [],

            total: null,
            loading: false,
            loaded: false,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: typeof(this.$store.state.searchQueries['ContractsPriceChanges']) != 'undefined' ? this.$store.state.searchQueries['ContractsPriceChanges'] : null,
            excelExportType: 'contractpricechange'
        }
    },

    computed: {
        paginated(){
            return this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    methods: {
        loadAsyncData() {
            // Set filter params & admin params
            let params = this.setParams(this.searchParams, (this.contract ? 'ContractsPriceChangesProd' : 'ContractsPriceChanges'))

            if(_.has(this.$route.query, 'confirmstops')){
                this.confirmStops = true
            } else {
                this.confirmStops = false
            }

            this.loading = true
            this.$emit('passLoading', true)

            // If contract is passed add to params.
            if(this.contract){
                params += `&contract=${this.contract}`
            }

            axios.get(`/api/contractpricechange?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: (this.contract ? 'ContractsPriceChangesProd' : 'ContractsPriceChanges'), query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching contract price changes:', error)
                this.total = null
                this.data = []
            }).then(() => {
                this.loading = false
                this.searchParams = null
                this.loaded = true

                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>
